const DashboardEndPoint = {
  getDashboardCount: {
    url: `/dashboard-count`,
    method: "GET",
  },
  getEarningStatistics: {
    url: `/earning-statistics`,
    method: "GET",
  },
  getBookingStatistics: {
    url: `/bookings-statistics`,
    method: "GET",
  },
  getUserStatistics: {
    url: `/user-statistics`,
    method: "GET",
  },
  getPaymentStats: {
    url: `/payment-statistics`,
    method: "GET",
  },
};

export default DashboardEndPoint;
